import { get } from './fetch';
import endpoints from '@src/config/endpoints';

const csrfTokenCall = () => {
  return get(endpoints.customer.getXsrfToken)
}

export default csrfTokenCall;